import axiosInstance from '../utils/axios';

const API_BASE = '/api/v2';

// axiosInstance injeta o Bearer no interceptor e devolve o corpo do erro em
// vez do AxiosResponse cru — ver front/src/services/campanhasService.js para
// o historico de por que as actions antigas com axios cru quebravam auth.
const mktPostsService = {

    listar: async (clienteId, params = {}) => {
        const response = await axiosInstance.get(`${API_BASE}/${clienteId}/mkt/posts`, { params });
        return response.data;
    },

    buscar: async (id) => {
        const response = await axiosInstance.get(`${API_BASE}/mkt/posts/${id}`);
        return response.data;
    },

    criar: async (clienteId, data) => {
        const response = await axiosInstance.post(`${API_BASE}/${clienteId}/mkt/posts`, data);
        return response.data;
    },

    editar: async (clienteId, id, data) => {
        const response = await axiosInstance.put(`${API_BASE}/${clienteId}/mkt/posts/${id}`, data);
        return response.data;
    },

    deletar: async (clienteId, id, { remote = false } = {}) => {
        const response = await axiosInstance.delete(`${API_BASE}/${clienteId}/mkt/posts/${id}`, {
            params: remote ? { remote: true } : undefined
        });
        return response.data;
    },

    // ids: exclusao em massa por selecao manual; account_id: "Excluir todos"
    // filtrado por conta. Sempre um dos dois — ver bulkDeletePosts no backend.
    deletarEmMassa: async (clienteId, { ids, accountId, remote = false } = {}) => {
        const response = await axiosInstance.delete(`${API_BASE}/${clienteId}/mkt/posts/bulk`, {
            data: { ids, account_id: accountId, remote }
        });
        return response.data;
    },

    // 200 -> publicado (ou parcialmente); 202 -> video do Instagram ainda
    // processando (o chamador deve pollar `buscar(id)`); 409 -> falta escopo
    // de publicacao, o corpo vem com { kind:'MISSING_SCOPE', platform, missing_scopes }.
    publicar: async (id) => {
        const response = await axiosInstance.post(`${API_BASE}/mkt/posts/${id}/publish`);
        return { status: response.status, ...response.data };
    },

    cancelar: async (id) => {
        const response = await axiosInstance.post(`${API_BASE}/mkt/posts/${id}/cancel`);
        return response.data;
    },

    retentar: async (id) => {
        const response = await axiosInstance.post(`${API_BASE}/mkt/posts/${id}/retry`);
        return response.data;
    },

    sincronizar: async (clienteId) => {
        const response = await axiosInstance.post(`${API_BASE}/${clienteId}/mkt/posts/sync`);
        return response.data;
    },

    capacidades: async (clienteId) => {
        const response = await axiosInstance.get(`${API_BASE}/${clienteId}/mkt/posts/capabilities`);
        return response.data;
    },

    uploadMidia: async (clienteId, formData, onUploadProgress) => {
        const response = await axiosInstance.post(`${API_BASE}/${clienteId}/mkt/media/upload`, formData, {
            headers: { 'Content-Type': 'multipart/form-data' },
            onUploadProgress
        });
        return response.data;
    }
};

export default mktPostsService;
